import React, { useState } from 'react';
import { Table, Tag, Typography, Select, Space } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useSessions } from '@/hooks/useSessions';
import type { Session } from '@/api/sessions';

const { Title } = Typography;

const SessionList: React.FC = () => {
  const [statusFilter, setStatusFilter] = useState<string>('');
  const [page, setPage] = useState(1);
  
  const { data, isLoading } = useSessions({ page, status: statusFilter });

  const columns: ColumnsType<Session> = [
    {
      title: 'Origem',
      dataIndex: 'source_device_name',
      key: 'source_device_name',
    },
    {
      title: 'Destino',
      dataIndex: 'target_device_name',
      key: 'target_device_name',
    },
    {
      title: 'Iniciado por',
      dataIndex: 'initiated_by_name',
      key: 'initiated_by_name',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: string) => (
        <Tag color={
          status === 'CONNECTED' ? 'green' :
          status === 'PENDING' ? 'orange' :
          status === 'DISCONNECTED' ? 'blue' : 'red'
        }>
          {status === 'CONNECTED' ? 'Conectado' :
           status === 'PENDING' ? 'Pendente' :
           status === 'DISCONNECTED' ? 'Desconectado' : 'Falhou'}
        </Tag>
      ),
    },
    {
      title: 'Início',
      dataIndex: 'started_at',
      key: 'started_at',
      render: (date: string) => new Date(date).toLocaleString('pt-BR'),
    },
    {
      title: 'Duração',
      dataIndex: 'duration',
      key: 'duration',
      render: (duration: string) => duration || '-',
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Title level={4}>Sessões</Title>
        <Space>
          <Select
            placeholder="Status"
            value={statusFilter}
            onChange={setStatusFilter}
            style={{ width: 150 }}
            allowClear
          >
            <Select.Option value="">Todas</Select.Option>
            <Select.Option value="CONNECTED">Conectado</Select.Option>
            <Select.Option value="PENDING">Pendente</Select.Option>
            <Select.Option value="DISCONNECTED">Desconectado</Select.Option>
            <Select.Option value="FAILED">Falhou</Select.Option>
          </Select>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={data?.results || []}
        loading={isLoading}
        rowKey="id"
        pagination={{
          current: page,
          total: data?.count || 0,
          pageSize: 20,
          onChange: setPage,
          showTotal: (total) => `Total: ${total} sessões`,
        }}
      />
    </div>
  );
};

export default SessionList;
